import React, { useState, useEffect } from 'react';
import { costos } from '../utils/api';
import toast from 'react-hot-toast';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', maximumFractionDigits:0 }).format(n || 0);

export default function CostosPage() {
  const [tab, setTab] = useState('cogs');
  const [cogsData, setCogsData] = useState(null);
  const [gastos, setGastos] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editVal, setEditVal] = useState('');
  const [search, setSearch] = useState('');
  const [loadingCogs, setLoadingCogs] = useState(true);
  const [newGasto, setNewGasto] = useState({ concepto:'', monto:'', categoria:'Otros', tipo:'fijo' });
  const [savingGasto, setSavingGasto] = useState(false);

  useEffect(() => {
    if (tab === 'cogs') loadCogs();
    if (tab === 'gastos') loadGastos();
  }, [tab]);

  const loadCogs = async () => {
    setLoadingCogs(true);
    try {
      const res = await costos.getCogs();
      setCogsData(res.data);
    } catch (err) {
      toast.error('Error cargando COGS');
    } finally {
      setLoadingCogs(false);
    }
  };

  const loadGastos = async () => {
    try {
      const res = await costos.getGastos();
      setGastos(res.data);
    } catch (err) {
      toast.error('Error cargando gastos');
    }
  };

  const saveCog = async (itemId, sku) => {
    try {
      await costos.updateCog(itemId, { costo: parseFloat(editVal), sku });
      toast.success('COGS actualizado');
      setEditingId(null);
      loadCogs();
    } catch (err) {
      toast.error('Error guardando COGS');
    }
  };

  const addGasto = async () => {
    if (!newGasto.concepto || !newGasto.monto) return toast.error('Completa concepto y monto');
    setSavingGasto(true);
    try {
      await costos.createGasto({ ...newGasto, monto: parseFloat(newGasto.monto), fecha: new Date().toISOString().split('T')[0] });
      toast.success('Gasto registrado');
      setNewGasto({ concepto:'', monto:'', categoria:'Otros', tipo:'fijo' });
      loadGastos();
    } catch (err) {
      toast.error('Error registrando gasto');
    } finally {
      setSavingGasto(false);
    }
  };

  const deleteGasto = async (id) => {
    try {
      await costos.deleteGasto(id);
      toast.success('Gasto eliminado');
      loadGastos();
    } catch (err) {
      toast.error('Error eliminando gasto');
    }
  };

  const filtered = cogsData?.items?.filter(i => !search || i.title?.toLowerCase().includes(search.toLowerCase()) || i.sku?.toLowerCase().includes(search.toLowerCase())) || [];

  const s = { fontFamily:"'Inter',sans-serif" };

  return (
    <div style={{ ...s, padding:'24px 28px' }}>
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontSize:22, fontWeight:700, color:'#fff', letterSpacing:'-0.8px', margin:0 }}>Gestión de Costos</h1>
        <p style={{ fontSize:12, color:'rgba(255,255,255,0.35)', marginTop:4 }}>Gastos operativos y costos de producto (COGS)</p>
      </div>

      <div style={{ display:'flex', gap:4, background:'rgba(255,255,255,0.05)', borderRadius:12, padding:4, marginBottom:20, width:'fit-content' }}>
        {[['cogs','Costos de Producto (COGS)'],['gastos','Gastos Operativos'],['calc','Calculadora']].map(([id,label]) => (
          <button key={id} onClick={() => setTab(id)}
            style={{ padding:'8px 18px', borderRadius:10, fontSize:12, fontWeight:600, border:'none', cursor:'pointer', fontFamily:'Inter,sans-serif',
              background: tab===id ? '#a3e635' : 'transparent', color: tab===id ? '#111' : 'rgba(255,255,255,0.4)' }}>
            {label}
          </button>
        ))}
      </div>

      {tab === 'cogs' && (
        <div>
          {cogsData && (
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginBottom:20 }}>
              <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, padding:16 }}>
                <div style={{ fontSize:10, color:'rgba(255,255,255,0.4)', fontWeight:600, textTransform:'uppercase', letterSpacing:'.5px', marginBottom:6 }}>Progreso COGS</div>
                <div style={{ fontSize:28, fontWeight:800, color:'#a3e635', letterSpacing:'-1px' }}>{cogsData.progreso}%</div>
                <div style={{ height:4, background:'rgba(255,255,255,0.06)', borderRadius:99, marginTop:10, overflow:'hidden' }}>
                  <div style={{ width:`${cogsData.progreso}%`, height:'100%', background:'#a3e635', borderRadius:99 }}></div>
                </div>
                <div style={{ fontSize:11, color:'rgba(255,255,255,0.3)', marginTop:6 }}>{cogsData.con_costo} con costo · {cogsData.sin_costo} sin costo</div>
              </div>
              <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, padding:16 }}>
                <div style={{ fontSize:10, color:'rgba(255,255,255,0.4)', fontWeight:600, textTransform:'uppercase', letterSpacing:'.5px', marginBottom:6 }}>Total productos</div>
                <div style={{ fontSize:28, fontWeight:800, color:'#fff', letterSpacing:'-1px' }}>{cogsData.total_items}</div>
                <div style={{ fontSize:11, color:'rgba(255,255,255,0.3)', marginTop:6 }}>SKUs en Mercado Libre</div>
              </div>
              <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, padding:16 }}>
                <div style={{ fontSize:10, color:'rgba(255,255,255,0.4)', fontWeight:600, textTransform:'uppercase', letterSpacing:'.5px', marginBottom:6 }}>Sin costo asignado</div>
                <div style={{ fontSize:28, fontWeight:800, color: cogsData.sin_costo > 0 ? '#fb7185' : '#a3e635', letterSpacing:'-1px' }}>{cogsData.sin_costo}</div>
                <div style={{ fontSize:11, color:'rgba(255,255,255,0.3)', marginTop:6 }}>productos sin COGS</div>
              </div>
            </div>
          )}

          <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:20 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
              <div style={{ fontSize:14, fontWeight:600, color:'#fff' }}>Productos y costos</div>
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar producto o SKU..."
                style={{ background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'8px 14px', fontSize:12, color:'#fff', fontFamily:'Inter,sans-serif', outline:'none', width:220 }} />
            </div>

            {loadingCogs ? (
              <div style={{ textAlign:'center', padding:40, color:'rgba(255,255,255,0.3)', fontSize:13 }}>Cargando...</div>
            ) : (
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                <thead>
                  <tr>
                    {['Producto','SKU','COGS (Costo)','Estado'].map(h => (
                      <th key={h} style={{ textAlign:'left', color:'rgba(255,255,255,0.3)', padding:'0 10px 12px', fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:'.4px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(item => (
                    <tr key={item.item_id} style={{ borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
                      <td style={{ padding:'12px 10px', display:'flex', alignItems:'center', gap:10 }}>
                        {item.thumbnail ? (
                          <img src={item.thumbnail.replace('http://','https://')} alt="" style={{ width:40, height:40, borderRadius:8, objectFit:'cover', background:'#222' }} onError={e => e.target.style.display='none'} />
                        ) : (
                          <div style={{ width:40, height:40, borderRadius:8, background:'rgba(255,255,255,0.05)', flexShrink:0 }}></div>
                        )}
                        <div style={{ color:'#fff', fontWeight:500, maxWidth:220, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.title || item.item_id}</div>
                      </td>
                      <td style={{ padding:'12px 10px', color:'rgba(255,255,255,0.4)', fontFamily:'monospace', fontSize:11 }}>{item.sku || '-'}</td>
                      <td style={{ padding:'12px 10px' }}>
                        {editingId === item.item_id ? (
                          <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                            <input type="number" value={editVal} onChange={e => setEditVal(e.target.value)}
                              style={{ width:100, background:'rgba(255,255,255,0.08)', border:'1px solid rgba(163,230,53,0.4)', borderRadius:8, padding:'5px 8px', fontSize:12, color:'#fff', fontFamily:'Inter,sans-serif', outline:'none' }} />
                            <button onClick={() => saveCog(item.item_id, item.sku)} style={{ padding:'5px 10px', borderRadius:8, background:'#a3e635', border:'none', fontSize:11, fontWeight:700, color:'#111', cursor:'pointer' }}>✓</button>
                            <button onClick={() => setEditingId(null)} style={{ padding:'5px 10px', borderRadius:8, background:'rgba(255,255,255,0.08)', border:'none', fontSize:11, color:'#fff', cursor:'pointer' }}>✕</button>
                          </div>
                        ) : (
                          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                            <span style={{ fontWeight:700, color: item.costo > 0 ? '#a3e635' : '#fb7185' }}>
                              {item.costo > 0 ? fmt(item.costo) : 'Sin costo'}
                            </span>
                            <button onClick={() => { setEditingId(item.item_id); setEditVal(item.costo || ''); }}
                              style={{ padding:'3px 8px', borderRadius:6, background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.08)', fontSize:10, color:'rgba(255,255,255,0.4)', cursor:'pointer' }}>
                              ✏️
                            </button>
                          </div>
                        )}
                      </td>
                      <td style={{ padding:'12px 10px' }}>
                        <span style={{ padding:'3px 10px', borderRadius:20, fontSize:10, fontWeight:700,
                          background: item.costo > 0 ? 'rgba(163,230,53,0.1)' : 'rgba(251,113,133,0.1)',
                          color: item.costo > 0 ? '#a3e635' : '#fb7185' }}>
                          {item.costo > 0 ? 'Con costo' : 'Sin costo'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {tab === 'gastos' && (
        <div>
          {gastos && (
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginBottom:20 }}>
              {[['Gastos fijos',fmt(gastos.fijos),'#fbbf24'],['Gastos variables',fmt(gastos.variables),'#a78bfa'],['Total costos',fmt(gastos.total),'#fb7185']].map(([l,v,c]) => (
                <div key={l} style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, padding:16 }}>
                  <div style={{ fontSize:10, color:'rgba(255,255,255,0.4)', fontWeight:600, textTransform:'uppercase', letterSpacing:'.5px', marginBottom:6 }}>{l}</div>
                  <div style={{ fontSize:24, fontWeight:800, color:c, letterSpacing:'-0.8px' }}>{v}</div>
                </div>
              ))}
            </div>
          )}

          <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:20, marginBottom:16 }}>
            <div style={{ fontSize:14, fontWeight:600, color:'#fff', marginBottom:16 }}>Registrar gasto</div>
            <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr auto', gap:10, alignItems:'end' }}>
              <div>
                <div style={{ fontSize:11, color:'rgba(255,255,255,0.4)', marginBottom:6, fontWeight:600 }}>CONCEPTO</div>
                <input value={newGasto.concepto} onChange={e => setNewGasto({...newGasto, concepto:e.target.value})} placeholder="Ej: Arriendo bodega"
                  style={{ width:'100%', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#fff', fontFamily:'Inter,sans-serif', outline:'none' }} />
              </div>
              <div>
                <div style={{ fontSize:11, color:'rgba(255,255,255,0.4)', marginBottom:6, fontWeight:600 }}>MONTO (COP)</div>
                <input type="number" value={newGasto.monto} onChange={e => setNewGasto({...newGasto, monto:e.target.value})} placeholder="500000"
                  style={{ width:'100%', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#fff', fontFamily:'Inter,sans-serif', outline:'none' }} />
              </div>
              <div>
                <div style={{ fontSize:11, color:'rgba(255,255,255,0.4)', marginBottom:6, fontWeight:600 }}>CATEGORÍA</div>
                <select value={newGasto.categoria} onChange={e => setNewGasto({...newGasto, categoria:e.target.value})}
                  style={{ width:'100%', background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#fff', fontFamily:'Inter,sans-serif', outline:'none' }}>
                  {['Arriendo','Nomina','Marketing','Logistica','Servicios','Otros'].map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize:11, color:'rgba(255,255,255,0.4)', marginBottom:6, fontWeight:600 }}>TIPO</div>
                <select value={newGasto.tipo} onChange={e => setNewGasto({...newGasto, tipo:e.target.value})}
                  style={{ width:'100%', background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#fff', fontFamily:'Inter,sans-serif', outline:'none' }}>
                  <option value="fijo">Fijo (mensual)</option>
                  <option value="variable">Variable</option>
                </select>
              </div>
              <button onClick={addGasto} disabled={savingGasto}
                style={{ padding:'10px 20px', borderRadius:10, background:'#a3e635', border:'none', fontSize:13, fontWeight:700, color:'#111', cursor:'pointer', fontFamily:'Inter,sans-serif', whiteSpace:'nowrap' }}>
                + Agregar
              </button>
            </div>
          </div>

          <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:20 }}>
            <div style={{ fontSize:14, fontWeight:600, color:'#fff', marginBottom:16 }}>Gastos registrados ({gastos?.gastos?.length || 0})</div>
            {!gastos?.gastos?.length ? (
              <div style={{ textAlign:'center', padding:40, color:'rgba(255,255,255,0.25)', fontSize:13 }}>No hay gastos registrados aún</div>
            ) : (
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                <thead>
                  <tr>{['Concepto','Monto','Categoría','Tipo',''].map(h => (
                    <th key={h} style={{ textAlign:'left', color:'rgba(255,255,255,0.3)', padding:'0 10px 12px', fontSize:11, fontWeight:600, textTransform:'uppercase', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {gastos.gastos.map(g => (
                    <tr key={g.id} style={{ borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
                      <td style={{ padding:'12px 10px', color:'#fff', fontWeight:500 }}>{g.concepto}</td>
                      <td style={{ padding:'12px 10px', color:'#fb7185', fontWeight:700 }}>{fmt(g.monto)}</td>
                      <td style={{ padding:'12px 10px', color:'rgba(255,255,255,0.4)' }}>{g.categoria}</td>
                      <td style={{ padding:'12px 10px' }}>
                        <span style={{ padding:'3px 10px', borderRadius:20, fontSize:10, fontWeight:700,
                          background: g.tipo==='fijo' ? 'rgba(251,191,36,0.1)' : 'rgba(167,139,250,0.1)',
                          color: g.tipo==='fijo' ? '#fbbf24' : '#a78bfa' }}>
                          {g.tipo==='fijo' ? 'Fijo' : 'Variable'}
                        </span>
                      </td>
                      <td style={{ padding:'12px 10px', textAlign:'right' }}>
                        <button onClick={() => deleteGasto(g.id)} style={{ padding:'4px 10px', borderRadius:6, background:'rgba(251,113,133,0.1)', border:'1px solid rgba(251,113,133,0.2)', fontSize:11, color:'#fb7185', cursor:'pointer' }}>Eliminar</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {tab === 'calc' && (
        <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:40, textAlign:'center', color:'rgba(255,255,255,0.3)', fontSize:14 }}>
          Calculadora de rentabilidad — próximamente
        </div>
      )}
    </div>
  );
}
